import React from 'react';
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { patchLocationLink, deleteLocationLink } from 'redux/location-links/actions';

import CommonLinkContainer
  from 'components/common/link-elements/CommonLinkContainer';
import LocationLinkItemHeaderContent
  from 'components/dashboard/location-links-content/LocationLinkItemHeaderContent';
import LocationLinkItemExpandedContent
  from 'components/dashboard/location-links-content/LocationLinkItemExpandedContent';

import './LocationLinkItem.css';


function LocationLinkItem({ item, patchLocationLink, deleteLocationLink }) {
  return (
    <div className="location-link-item__component">
      <CommonLinkContainer
        linkItem={item}
        patchLinkFunction={patchLocationLink}
        allowExpand
        headerContent={
          <LocationLinkItemHeaderContent
            key={`location-link-item-header-content-key-${item.id}`}
            item={item}
            deleteLocationLink={deleteLocationLink}
          />
        }
        expandedContent={
          <LocationLinkItemExpandedContent
            key={`location-link-item-expanded-content-key-${item.id}`}
            item={item}
            deleteLocationLink={deleteLocationLink}
          />
        }
      />
    </div>
  );
}

LocationLinkItem.propTypes = {
  patchLocationLink: PropTypes.func.isRequired,
  deleteLocationLink: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default connect(
  null,
  {
    patchLocationLink,
    deleteLocationLink,
  },
)(LocationLinkItem);
